import { axiosWithAuth } from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchViewedProducts = createAsyncThunk(
  'recentlyViewed/fetchViewedProducts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosWithAuth().get(`/api/recently-viewed`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const addViewedProducts = createAsyncThunk(
  'recentlyViewed/addViewedProducts',
  async (products, { rejectWithValue }) => {
    try {
      const body = {
        items: products?.map((product) => ({ id: product?.id })),
      };
      const response = await axiosWithAuth().post(
        `/api/recently-viewed`,
        body,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);
